import React from 'react'
import EditPeople from '../People/EditPeople'

const EditTeacher = () => <EditPeople kind="teacher" />

export default EditTeacher
